// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2sVo0","label":"Radio_label__1fEfi","checkMark":"Radio_checkMark__jF5Zj","disabled":"Radio_disabled__2AV7I"};